/**
 * Gram VPN targets Russian speakers only: Russian UI or Russian among the
 * system languages. Everybody else gets Stakee instead. One rule for every
 * ad place, so a visitor sees the same campaign all over the site.
 *
 * @param  {String} locale  current UI locale ($i18n.locale)
 * @return {Boolean}
 */
export const isRussianSpeaker = function isRussianSpeakingVisitor(locale) {
    return locale === 'ru' || navigator.languages.some(lang => /^ru\b/i.test(lang));
};
